<template>
  <div>
    <button
      type="button"
      class="btn btn-primary mb-1"
      @click="openCreateHouseModal()"
      v-if="from == 'house-list'"
    >
      <span class="align-middle ml-25">{{ $t("Create House") }}</span>
    </button>

    <a
      href="#"
      class="pl-0"
      v-if="from == 'proposal-modal'"
      @click="openCreateHouseModal()"
      >Create house</a
    >

    <div
      class="modal fade text-left"
      id="modal-create-house"
      role="dialog"
      aria-labelledby="create-modal-title"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title" id="create-modal-title">
              {{ $t("Create House") }}
            </h3>
            <button
              type="button"
              class="close rounded-pill"
              @click="closeModal()"
              aria-label="Close"
            >
              <em class="bx bx-x"></em>
            </button>
          </div>
          <div class="modal-body">
            <Alert
              v-if="error == 'fill-data'"
              :text="$t('Validation for the required fields')"
              type="danger"
              dismissable="false"
            />
            <Alert
              v-if="error == 'error-message'"
              :text="errorText"
              type="danger"
              dismissable="false"
            />
            <Alert
              v-if="error == 'max-months-error'"
              :text="$t('Advance payment for month validation message')"
              type="danger"
              dismissable="false"
            />
            <form class="form">
              <div class="form-body">
                <div class="row">
                  <div class="col-md-6 col-12">
                    <div>
                      <label for>House Name</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="houseName"
                      />
                    </div>
                  </div>
                  <div class="col-md-6 col-12">
                    <div>
                      <label for>{{ $t("Owner") }}</label>
                      <select
                        id="owner-select"
                        class="form-control select2"
                        style="width: 100%"
                        :disabled="inviteLandlord"
                      >
                        <option value="Select owner..." selected>
                          Select owner...
                        </option>
                        <option
                          :value="JSON.stringify(landlord)"
                          v-for="(landlord, index) in landlords"
                          :key="index"
                        >
                          {{ landlord.name ? landlord.name : "-" }}
                        </option>
                      </select>
                      <small v-if="!inviteLandlord">
                        <a href="#" @click="toggleInviteLandlord()" class="pl-0"
                          >Invite landlord</a
                        >
                      </small>
                      <small v-else>
                        <a href="#" @click="toggleInviteLandlord()" class="pl-0"
                          >Choose landlord from list</a
                        >
                      </small>
                    </div>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-6 col-sm-12">
                    <label for>{{ $t("Currency") }}</label>
                    <select class="form-control" v-model="currency">
                      <option value="LBP">{{ $t("LBP") }}</option>
                      <option value="JOD">{{ $t("JOD") }}</option>
                      <option value="PLN">{{ $t("PLN") }}</option>
                      <option value="UAH">{{ $t("UAH") }}</option>
                      <option value="USD">{{ $t("USD") }}</option>
                      <option value="CAD">{{ $t("CAD") }}</option>
                      <option value="PEN">{{ $t("PEN") }}</option>
                      <option value="COP">{{ $t("COP") }}</option>
                      <option value="EUR">{{ $t("EUR") }}</option>
                    </select>
                  </div>
                  <div class="col-md-6 col-sm-12">
                    <label for>{{ $t("Asking Deposit") }}</label>
                    <input
                      type="number"
                      step="1.00"
                      min="0"
                      class="form-control"
                      v-model="askingDeposit"
                    />
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-6 col-12">
                    <div>
                      <label for>{{ $t("Country") }}</label>
                      <select class="form-control" v-model="houseCountry">
                        <option
                          v-for="(aC, index) in activeCountries"
                          :key="index"
                          :value="aC.toLowerCase()"
                        >
                          {{ countryName(aC) }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6 col-sm-12">
                    <label for>Available Date</label>
                    <div
                      class="form-group position-relative has-icon-left"
                    >
                      <input
                        type="text"
                        class="form-control"
                        :placeholder="$t('Select Date')"
                        id="date-input"
                      />
                      <div class="form-control-position">
                        <em class="bx bx-calendar"></em>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-6 col-sm-12">
                    <label for>{{
                      $t("Asking Advance Payments (In months)")
                    }}</label>
                    <input
                      type="number"
                      step="1"
                      min="0"
                      class="form-control"
                      v-model="askingAdvanceMonths"
                    />
                  </div>
                  <div class="col-md-6 col-sm-12">
                    <label for>{{ $t("Asking Rent") }}</label>
                    <input
                      type="number"
                      step="1.00"
                      min="0"
                      class="form-control"
                      v-model="askingRent"
                    />
                  </div>
                </div>
              </div>
              <div v-if="inviteLandlord">
                <br />
                <div class="text-left my-2">
                  <h4 class="text-bold-600">{{ $t("Property Owner") }}</h4>
                  <hr />
                </div>

                <div class="form-group row">
                  <div class="col-md-6 col-sm-12">
                    <label for>Name</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="ownerName"
                    />
                  </div>
                  <div class="col-md-6 col-sm-12">
                    <label for>{{ $t("Language") }}</label>
                    <select class="form-control" v-model="ownerLanguage">
                      <option value="en">{{ $t("English") }}</option>
                      <option value="ar">{{ $t("Arabic") }}</option>
                    </select>
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-md-6 col-sm-12">
                    <label for>{{ $t("Phone Number") }}</label>
                    <input
                      type="tel"
                      id="phoneNumber"
                      class="form-control"
                      v-model="invitePhoneNumber"
                    />
                  </div>
                  <div class="col-md-6 col-sm-12">
                    <label for>Email Address</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="ownerEmail"
                    />
                  </div>
                </div>
              </div>

              <div class="text-right mt-2">
                <button
                  class="btn btn-primary"
                  type="button"
                  @click="createHouse()"
                  style="margin-top: 0px !important"
                >
                  Create Draft
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/app-assets/js/scripts/extensions/ext-component-block-ui.js";
import { getCountryName } from "@/app-assets/js/get-countries.js";
import Alert from "@/components/Alerts";
export default {
  props: ["from"],
  data() {
    return {
      landlords: [],
      error: "",
      errorText: "",
      activeCountries: [],

      houseName: "",
      houseCountry: "lb",
      availableDate: "",
      askingRent: "",
      currency: "LBP",
      askingDeposit: "",
      askingAdvanceMonths: "",

      inviteLandlord: false,
      phoneNumberObj: null,
      invitePhoneNumber: "",
      ownerName: "",
      ownerEmail: "",
      ownerLanguage: "en",
    };
  },

  computed: {
    isSuperadmin() {
      return this.$store.state.currentUser.user.type === "superadmin";
    },
  },

  components: {
    Alert,
  },

  methods: {
    createHouse() {
      this.error = "";
      let availabilityStart = "";
      let owner = {};

      if (this.inviteLandlord) {
        owner = {
          name: this.ownerName,
          language: this.ownerLanguage,
          email: this.ownerEmail,
          phoneNumber: this.invitePhoneNumber,
        };
      } else {
        if ($("#owner-select").val() != "Select owner...") {
          let v = JSON.parse($("#owner-select").val());
          owner = {
            name: v.name,
            language: v.language,
            email: v.email ? v.email : null,
            phoneNumber: v.phoneNumber ? v.phoneNumber : null,
          };
        } else {
          owner = {
            email: "",
            phoneNumber: "",
          };
        }
      }

      if ($("#date-input").val().trim() != "") {
        availabilityStart = $("#date-input").val().split("/");
        availabilityStart = `${availabilityStart[2]}-${availabilityStart[0]}-${availabilityStart[1]}T00:00Z`;
      }

      if (
        // Property Data
        this.houseName.trim() != "" &&
        availabilityStart.trim() != "" &&
        this.askingRent != "" &&
        this.askingDeposit != "" &&
        this.askingAdvanceMonths != "" &&
        this.askingAdvanceMonths <= 36 &&
        // Owner Data
        (owner.email.trim() != "" || owner.phoneNumber.trim() != "")
      ) {
        $.blockUI({
          message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
          overlayCSS: {
            backgroundColor: "#fff",
            opacity: 0.8,
            cursor: "wait",
          },
          css: {
            border: 0,
            padding: 0,
            backgroundColor: "transparent",
          },
        });

        this.$apiCall
          .post("/v1/properties", {
            name: this.houseName,
            owner: owner,
            availabilityStart: availabilityStart,
            currency: this.currency.toLowerCase(),
            country: this.houseCountry,
            askingMonthlyRent: Number(this.askingRent),
            askingDeposit: Number(this.askingDeposit),
            askingAdvanceMonths: Number(this.askingAdvanceMonths),
          })
          .then((response) => {
            if (this.from == "house-list") {
              location.href = `/houses/${response.data.uid}`;
            } else if (this.from == "proposal-modal") {
              this.$emit("houseCreated");
              $("#modal-create-house").modal("hide");
            }
            $.unblockUI();
          })
          .catch((error) => {
            console.log(error);
            this.error = "error-message";
            this.errorText = `$t('Ops') ${error.response.data.message}`;
            $.unblockUI();
          });
      } else {
        if (this.askingAdvanceMonths> 36) {
          this.error = "max-months-error";
        } else {
          this.error = "fill-data";
        }
      }
    },

    toggleInviteLandlord() {
      this.inviteLandlord = !this.inviteLandlord;
      if (this.inviteLandlord) {
        setTimeout(() => {
          this.initTelInput();
        }, 100);
      }
    },

    openCreateHouseModal() {
      this.error = "";
      if (!this.landlords.length) {
        $.blockUI({
          message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
          overlayCSS: {
            backgroundColor: "#fff",
            opacity: 0.8,
            cursor: "wait",
          },
          css: {
            border: 0,
            padding: 0,
            backgroundColor: "transparent",
          },
        });
        this.landlords = [];
        this.$apiCall
          .get("/v1/users?type=landlord")
          .then((response) => {
            this.landlords = response.data.data;
            $(".select2").select2();
            $.unblockUI();
            $("#modal-create-house").modal();
          })
          .catch((error) => {
            $.unblockUI();
          });
      } else {
        $("#modal-create-house").modal();
      }
    },

    getActiveCountries() {
      const countries = localStorage.getItem("activeCountries");
      this.activeCountries =
        countries && countries != "" ? countries.split(",") : ["LB", "JO"];
    },

    countryName(element) {
      if (element) {
        return getCountryName(element.toUpperCase());
      }
    },

    initTelInput() {
      let input = document.querySelector("#phoneNumber");
      this.phoneNumberObj = intlTelInput(input);
    },

    closeModal() {
      $("#modal-create-house").modal("hide");
    },
  },

  watch: {
    invitePhoneNumber: function (value) {
      this.invitePhoneNumber = value.replace(/[^\d|\-+]/g, "");
    },
  },

  mounted() {
    this.getActiveCountries();
    setTimeout(() => {
      const pD = $("#date-input").pickadate(
        {
          format: "mm/dd/yyyy",
        },
        200
      );
    });
  },
};
</script>